import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const ViewMoreWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center'
}));

export default ViewMoreWrapper;
